module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Comfort",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35,55 C15,44.2673769 5,33.3022295 5,22.1045577 C5,5.63129001 17.9194693,-0.618839965 34.0470003,10.8571114 C34.2579709,11.0072328 33.7452803,13.3857136 32.5089286,17.9925537 L35,19.883016 L34.0470003,25.5086263 L37.4320592,19.605306 L34.4536133,17.3307292 C35.3981336,13.0542529 35.8786238,10.9101395 35.8950839,10.8983892 C52.0495894,-0.633785039 65,5.61157559 65,22.1045577 C65,33.3022295 55,44.2673769 35,55 Z M18.2973033,32.1145052 C17.5578827,32.931545 19.1344412,38.7749259 20.1608004,39.0691712 C20.84504,39.2653347 24.2421377,38.665668 30.3520937,37.270171 L28.0227223,28.5768385 C22.0320567,30.3905898 18.7902504,31.5698121 18.2973033,32.1145052 Z M49.0017382,24.0633227 C48.3107738,23.8138118 44.8948174,24.2945562 38.753869,25.505556 L40.7784285,34.2748866 C46.8283456,32.6385868 50.1093313,31.5732203 50.6213857,31.0787872 C51.3894674,30.3371375 50.0381847,24.437589 49.0017382,24.0633227 Z M28.9886481,28.3180195 L31.3180195,37.0113519 L40.0113519,34.6819805 L37.6819805,25.9886481 L28.9886481,28.3180195 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdc9044e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/comfort.vue
// module id = 668
// module chunks = 1